import { createEffect } from 'effector';

import { STRIPE_ID } from '@m/constants/PaymentEnums';
import { apiFetch } from '@m/utils/http';
import { fetchCustomerVisits } from 'apps/customer/state/visit';

export const fetchPaymentMethods = createEffect({
  handler: ({ userId }: { userId: number }) => apiFetch(`/user/${userId}/payment-methods`),
});

export const addStripePaymentMethod = createEffect({
  handler: ({
    userId,
    cardToken,
    vendorPaymentMethodId,
    vendorSetupIntentId,
    preAuth,
  }: {
    cardToken?: string;
    preAuth?: 'sync' | 'async';
    userId?: number;
    vendorPaymentMethodId?: string;
    vendorSetupIntentId?: string;
  }) =>
    apiFetch(
      preAuth
        ? `/user/${userId}/payment-methods?preAuth=${preAuth}`
        : `/user/${userId}/payment-methods`,
      {
        method: 'POST',
        body: {
          ...(vendorPaymentMethodId && vendorSetupIntentId
            ? { vendorPaymentMethodId, vendorSetupIntentId }
            : { cardToken }),
          paymentProvider: {
            id: STRIPE_ID,
            name: 'Stripe',
          },
        },
      },
    ),
});

export const setDefaultPaymentMethod = createEffect({
  handler: ({ paymentMethodId }: { paymentMethodId: number }) =>
    apiFetch('/user/default-payment-method', {
      method: 'POST',
      params: { paymentMethodId },
    }),
});

export const deletePaymentMethod = createEffect({
  handler: ({ paymentMethodId }: { paymentMethodId: number }) =>
    apiFetch(`/customer/payment-method/${paymentMethodId}`, { method: 'DELETE' }),
});

export const payForOverdueVisits = createEffect({
  handler: async ({
    cardToken,
    cardId,
    expressCheckoutOptions,
    vendorPaymentMethodId,
    numItems,
  }: {
    cardId?: number;
    cardToken?: string;
    expressCheckoutOptions?: {
      vendorPaymentMethodId: string;
      vendorTransactionId: string;
    };
    numItems: number;
    vendorPaymentMethodId?: string;
  }) => {
    let body;

    if (cardToken) {
      body = {
        cardToken,
        paymentProvider: {
          id: STRIPE_ID,
          name: 'Stripe',
        },
      };
    }

    if (cardId) {
      body = {
        paymentMethodId: cardId,
      };
    }

    if (expressCheckoutOptions) {
      body = {
        ...expressCheckoutOptions,
        paymentProvider: {
          id: STRIPE_ID,
          name: 'Stripe',
        },
      };
    }

    if (vendorPaymentMethodId) {
      body = {
        vendorPaymentMethodId,
        paymentProvider: {
          id: STRIPE_ID,
          name: 'Stripe',
        },
      };
    }

    const response = await apiFetch(`/customer/payment-due/pay?numItems=${numItems}`, {
      method: 'POST',
      body,
    });

    if (response.success) {
      await fetchCustomerVisits();
    }

    return response;
  },
});
